import {Route} from 'react-router-dom';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import PaymentStatus from './PaymentStatus';
import {getSelectedPrimaryAccount} from './Selectors';
import {faAngleDoubleLeft} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class PaymentStatusPage extends Component {

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className={"col-12"}>
            <Route render={({history}) => {
              return <button
                type="button"
                id="closePaymentStatus"
                className="btn btn-primary btn-sm buttonColor float-right d-print-none"
                onClick={() => {
                  history.goBack()
                }}
              >
                {' '}
                <FontAwesomeIcon icon={faAngleDoubleLeft} /> Back{' '}
              </button>
            }}/>
          </div>
        </div>
        <br/>
        <div className="row">
          <div className={"col-12"}>
            <PaymentStatus/>
          </div>
        </div>
      </div>
    )
  }
}

export default connect((store, props) => ({
  selectedInvoices: store.default.selectedInvoices,
  secondaryAccounts: store.user_options.secondaryAccounts,
  selectedPrimaryAccount: getSelectedPrimaryAccount(store, props),
  userCustomerDetails: store.user_options.primaryAccounts,
}))(PaymentStatusPage);
